import { render, staticRenderFns } from "./ParentDialogPopup.vue?vue&type=template&id=012cb26c&scoped=true"
import script from "./ParentDialogPopup.vue?vue&type=script&lang=js"
export * from "./ParentDialogPopup.vue?vue&type=script&lang=js"
import style0 from "./ParentDialogPopup.vue?vue&type=style&index=0&id=012cb26c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012cb26c",
  null
  
)

export default component.exports